import * as React from "react";
import { Helmet } from "react-helmet";
import { useStaticQuery } from "gatsby";

var SEO = function SEO(_ref) {
  var description = _ref.description,
      lang = _ref.lang,
      meta = _ref.meta,
      title = _ref.title,
      featuredImage = _ref.featuredImage;

  var _ref2 = useStaticQuery("91047477"),
      site = _ref2.site;

  var metaDescription = description || site.siteMetadata.description;
  var siteUrl = site.siteMetadata.siteUrl;
  return /*#__PURE__*/React.createElement(Helmet, {
    htmlAttributes: {
      lang: lang || site.siteMetadata.lang || 'en'
    },
    title: title,
    titleTemplate: "%s | " + site.siteMetadata.title,
    meta: [{
      name: "description",
      content: metaDescription
    }, {
      property: "og:title",
      content: title
    }, {
      property: "og:description",
      content: metaDescription
    }, {
      property: "og:images",
      content: featuredImage && "" + (siteUrl || '') + featuredImage
    }, {
      property: "og:image",
      content: featuredImage && "" + (siteUrl || '') + featuredImage
    }, {
      property: "og:type",
      content: "website"
    }, {
      name: "twitter:card",
      content: "summary_large_image"
    }, {
      name: "twitter:creator",
      content: site.siteMetadata.author
    }, {
      name: "twitter:title",
      content: title
    }, {
      name: "twitter:description",
      content: metaDescription
    }, {
      name: "twitter:image",
      content: featuredImage && "" + (siteUrl || '') + featuredImage
    }].concat(meta)
  });
};

SEO.defaultProps = {
  lang: "",
  meta: [],
  description: ""
};
export default SEO;